<template>
  <div class="main-dashboard-panel startup-settings">
    <div class="panel-topnav container-fluid">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">
            Settings
          </h3>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid pane">
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-3 control-label">
                Public visibility
                <Fader ref="saveIndicator">
                  <p class="text-success">Saved</p>
                </Fader>
              </label>

              <div
                class="col-sm-9"
                :class="{ 'loader-cover': fetchInProgress }"
              >
                <div class="radio hidden">
                  <label>
                    <input
                      v-model="privacy"
                      type="radio"
                      name="visibility"
                      :value="DRAFT"
                    />
                    <span>Draft</span>
                    <span class="text-muted"
                      >Your profile is invisible for Vestbee users but you can
                      apply to open programs and events</span
                    >
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input
                      v-model="privacy"
                      type="radio"
                      name="visibility"
                      :value="PRIVATE"
                    />
                    <span>Private</span>
                    <span class="text-muted"
                      >Your profile is invisible for Vestbee users but you can
                      apply to open programs and events</span
                    >
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input
                      v-model="privacy"
                      type="radio"
                      name="visibility"
                      :value="PUBLIC"
                    />
                    <span>Public</span>
                    <span class="text-muted"
                      >Your profile is visible for Vestbee users</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Fader from '@/components/Fader'

const PUBLIC = 'PUBLIC'
const PRIVATE = 'PRIVATE'
const DRAFT = 'DRAFT'

export default {
  components: { Fader },
  data: () => ({ PUBLIC, PRIVATE, DRAFT, showSaveLabel: false }),
  computed: {
    privacy: {
      get() {
        return this.$store.state.startupProfile.startup.is_published
          ? PUBLIC
          : PRIVATE
      },
      set(value) {
        const attr = 'is_published'
        value = value === PUBLIC
        this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
        this.saveChanges()
      },
    },
    ...mapState({
      userFetchInProgress: (state) => state.user.fetchInProgress,
      startupFetchInProgress: (state) => state.startupProfile.fetchInProgress,
    }),
    fetchInProgress() {
      return this.userFetchInProgress || this.startupFetchInProgress
    },
    ...mapGetters({
      publicLink: 'startupProfile/publicLink',
    }),
  },
  methods: {
    showSave() {
      this.$refs.saveIndicator.show()
    },
    async saveChanges() {
      try {
        const fields = ['is_published']
        await this.$store.dispatch('startupProfile/saveChanges', { fields })
        this.showSave()
        this.$store.dispatch('notifications/addItem', {
          type: 'success',
          content: 'Changes saved',
          timeout: 2000,
        })
      } catch (error) {
        this.$store.dispatch('notifications/addItem', {
          type: 'danger',
          content: 'Something went wrong',
          timeout: 2000,
        })
        throw error
      }
    },
  },
}
</script>
